import React, { useState } from 'react';
import { Box, Modal, Typography, Divider } from '@mui/material';
import PropTypes from 'prop-types';
import { ReactComponent as CloseModalIcon } from '../../../../assets/images/close-modal.svg';
import { CustomButton } from '../../../../components/CustomButton';
import { CustomInputTextArea } from '../../../../components/CustomInputTextArea';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  minHeight: 452,
  bgcolor: 'background.paper',
  boxShadow: '0px 12px 32px rgba(42, 70, 94, 0.03)',
  borderRadius: '12px',
  outline: 'none'
};

export const ModalReason = ({
  showModal,
  setShowModal,
  submit
}) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = () => {
    submit(reason);
    setReason('');
  }

  const handleReason = (event) => {
    const value = event.target.value;
    if (value.length > 2500) setError(true);
    else {
      setReason(value);
      setError(false);
    }
  }

  return (
    <Modal open={showModal} onClose={() => setShowModal(false)} data-testid="ModalReason">
      <Box sx={style}>
        <Box display="flex" justifyContent="space-between" alignItems="center" p="24px">
          <Typography variant="h5" fontWeight={500}>
            Причина отклонения
          </Typography>
          <CloseModalIcon cursor={'pointer'} onClick={() => setShowModal(false)} data-testid="CloseModal"/>
        </Box>
        <Divider />
        <Box p="24px">
          <CustomInputTextArea
            value={reason}
            onChange={handleReason}
            style={{ height: 250, width: '100%' }}
            placeholder="Причина"
            error={error ? reason : undefined}
            onPaste={e => e.clipboardData.getData('text').length > 2500 && e.preventDefault()}
          />
          <Typography color={error ? "error.main" : "text.secondary"}>До 2500 символов.</Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '24px'
            }}>
            <CustomButton
              color="secondary"
              variant="contained"
              sx={{ marginRight: '16px' }}
              onClick={() => setShowModal(false)}
            >
              Отмена
            </CustomButton>
            <CustomButton
              variant="contained"
              onClick={reason ? handleSubmit : undefined}
              data-testid="SubmitButton"
              disabled={!reason}
            >
              Отправить
            </CustomButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

ModalReason.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  submit: PropTypes.func,
};
